<script>
import leftButtonActive from "@/assets/htp/left-active.png"
import leftButtonInactive from "@/assets/htp/left-inactive.png"
import rightButtonActive from "@/assets/htp/right-active.png"
import rightButtonInactive from "@/assets/htp/right-inactive.png"
import { mapState } from "vuex"
import FreeTutorialComponent1 from "@/views/components/FreeTutorialComponent1.vue"
import VipTutorialCompnent from "@/views/components/VipTutorialCompnent.vue"

export default {
  name: "how-to-play",
  components: {
    FreeTutorialComponent1,
    VipTutorialCompnent,
  },

  data() {
    return {
      openTab: 'free',
      modal: false,
      freePrizesExpanded: false,
      vipPrizesExpanded: false,
      leftButtonActive: leftButtonActive,
      leftButtonInactive: leftButtonInactive,
      rightButtonActive: rightButtonActive,
      rightButtonInactive: rightButtonInactive,
      showTutorial: false,
      currentFreeSlide: 1,
      currentVipSlide: 1,
      freeImages: {
        one: "htp-1",
        two: "htp-2",
      },
      freeHeading: {
        one: "The Basics",
        two: "Guess Music Trivia",
      },
      freeText: {
        one: "You have 20 seconds to answer each multiple choice, music question. Each correct answer is worth 10 coins!\n" +
            "\n" +
            "Race the clock and answer \n" +
            "all 7 questions for a chance to WIN airtime and unlock prizes.",
        two: "Put your music knowledge to the test.  Answer multiple choice questions about songs, artists, albums and more." + "\n" + "Let's groove to victory!",
      },
      vipImages: {
        one: "htp-1",
        two: "htp-2",
        three: "htp-3",
        four: "htp-4",
      },
      vipHeading: {
        one: "The Basics",
        two: "Guess Music Trivia",
        three: "Guess the Song",
        four: "Bonus Round",
      },
      vipText: {
        one: "You have 20 seconds to answer each multiple choice, music question. Each correct answer is worth 10 coins!\n" +
            "\n" +
            "Race the clock and answer \n" +
            "all 7 questions for a chance to WIN airtime and unlock prizes.",
        two: "Put your music knowledge to the test.  Answer multiple choice questions about songs, artists, albums and more." + "\n" + "Let's groove to victory!",
        three: "Catch that tune! \n" +
            "Part of song will play and you must identify the song's name by listening to its tune.\n" +
            "\n" +
            "Your ears are your greatest weapon here!",
        four: "Think fast, you have 10 seconds to answer 1 question.  If you get the question correct your\n" +
            "coins will be doubled.\n" +
            "\n" +
            "But be careful, one wrong answer will halve your coins."
      },
    }
  },

  mounted() {
      this.showTutorial = false

  },

  computed: {
    ...mapState(['isFreeUser','userStats']),
    // Get current slide data for free tab
    currentFreeImage() {
      const keys = Object.keys(this.freeImages)
      return this.freeImages[keys[this.currentFreeSlide - 1]]
    },
    currentFreeHeading() {
      const keys = Object.keys(this.freeHeading)
      return this.freeHeading[keys[this.currentFreeSlide - 1]]
    },
    currentFreeText() {
      const keys = Object.keys(this.freeText)
      return this.freeText[keys[this.currentFreeSlide - 1]]
    },
    // Get current slide data for vip tab
    currentVipImage() {
      const keys = Object.keys(this.vipImages)
      return this.vipImages[keys[this.currentVipSlide - 1]]
    },
    currentVipHeading() {
      const keys = Object.keys(this.vipHeading)
      return this.vipHeading[keys[this.currentVipSlide - 1]]
    },
    currentVipText() {
      const keys = Object.keys(this.vipText)
      return this.vipText[keys[this.currentVipSlide - 1]]
    },
    // Total slides for each tab
    totalFreeSlides() {
      return Object.keys(this.freeImages).length
    },
    totalVipSlides() {
      return Object.keys(this.vipImages).length
    },
  },

  methods: {
    toggleTab(tab) {
      this.openTab = tab
    },
    // Navigation for free tab
    previousFreeSlide() {
      if (this.currentFreeSlide > 1) {
        this.currentFreeSlide--
      }
    },
    nextFreeSlide() {
      if (this.currentFreeSlide < this.totalFreeSlides) {
        this.currentFreeSlide++
      }
    },
    // Navigation for vip tab
    previousVipSlide() {
      if (this.currentVipSlide > 1) {
        this.currentVipSlide--
      }
    },
    nextVipSlide() {
      if (this.currentVipSlide < this.totalVipSlides) {
        this.currentVipSlide++
      }
    },
    toggleFreePrizes() {
      this.freePrizesExpanded = !this.freePrizesExpanded
    },
    toggleVipPrizes() {
      this.vipPrizesExpanded = !this.vipPrizesExpanded
    },
    openTutorial() {
      // Always open when button is clicked
      this.showTutorial = true
    },
    handleClose() {
      this.showTutorial = false
      localStorage.setItem('tutorialCompleted', 'true')
    }
  }
}
</script>


<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-12 position-relative">
    <div class="d-flex justify-content-between align-items-center col-11 mt-4 mb-3 ">
      <img :src="isFreeUser ? require('@/assets/logos/logo-free.png') : require('@/assets/logos/logo-vip.png')"  class="col-5" alt="logo" />
      <div class="d-flex flex-column justify-content-center align-items-end col-5">
        <div class="d-flex justify-content-center align-items-center  col-5" style="border: 2px solid black; border-radius: 15px">
          <div class="col-4 mt-2 mb-2 fw-bold">{{ userStats?.TotalCoins || 0 }}</div>
          <img src="@/assets/gameplay/coins-medium.png" class="col-4 mt-2 mb-2" alt="coins" />
        </div>
      </div>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center col-12 mt-4 mb-3">
      <div class="d-flex justify-content-between align-items-center col-11">
        <div @click="toggleTab('free')" class="d-flex flex-column justify-content-center align-items-center col-5">
          <div :class="openTab === 'free' ? 'tab-text' : 'tab-text-inactive'"
               class="d-flex justify-content-center align-items-center text-uppercase col-12">Free
          </div>
          <div :class="openTab === 'free' ? 'tab-underline' : 'tab-underline-inactive'" class="col-12"></div>
        </div>
        <div @click="toggleTab('vip')" class="d-flex flex-column justify-content-center align-items-center col-5">
          <div :class="openTab === 'vip' ? 'tab-text' : 'tab-text-inactive'"
               class="d-flex justify-content-center align-items-center text-uppercase col-12">Vip
          </div>
          <div :class="openTab === 'vip' ? 'tab-underline' : 'tab-underline-inactive'" class="col-12"></div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center col-11 mt-4">
      <div class="col-6">
        <div class="fw-bold" style="font-size: 17px">How It Works</div>
        <div>Swipe to learn how to play & win</div>
      </div>
      <div class="col-4 tutorial-btn text-center text-uppercase fw-bold" @click = "openTutorial">Tutorial</div>
    </div>

    <!-- Conditionally render correct tutorial -->
    <FreeTutorialComponent1
        v-if="isFreeUser && showTutorial"
        @closeTutorial="handleClose"
    />

    <VipTutorialCompnent
        v-else-if="!isFreeUser && showTutorial"
        @closeTutorial="handleClose"
    />


    <!-- Tab Content -->
    <div v-if="openTab === 'free'" class="d-flex flex-column justify-content-center align-items-center col-11 mt-4">
      <div class="d-flex flex-column justify-content-start align-items-center col-12 position-relative"
           style="
                height: 38vh;
      border-radius: 11px;
      background: rgba(255, 255, 255, 0.80);"
      >
        <div class="d-flex justify-content-center align-items-center col-12">
          <div class="col-5 mt-3">
            <div class="fw-bold col-12 heading mb-2">{{ currentFreeHeading }}</div>
            <div class="col-12 text-start" style="white-space: pre-line;">{{ currentFreeText }}</div>
          </div>
          <div class="col-5">
            <img :src="require(`@/assets/htp/${currentFreeImage}.png`)" class="col-12" />
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center gap-2 mt-3 mb-3 col-5" style="position: absolute; bottom: 0; ">
          <img
              :src="currentFreeSlide > 1 ? leftButtonActive : leftButtonInactive"
              class="col-3"
              @click="previousFreeSlide"
              :style="currentFreeSlide > 1 ? 'cursor: pointer' : ''"
          />
          <img
              :src="currentFreeSlide < totalFreeSlides ? rightButtonActive : rightButtonInactive"
              class="col-3"
              @click="nextFreeSlide"
              :style="currentFreeSlide < totalFreeSlides ? 'cursor: pointer' : ''"
          />
        </div>
      </div>

      <div class="d-flex flex-column justify-content-center align-items-start mt-4 col-12">
        <div class="fw-bold text-start" style="font-size: 18px">Available Prizes</div>
        <div class="d-flex flex-column justify-content-center align-items-center col-12">
          <transition name="accordion" mode="out-in">
            <img
                v-if="!freePrizesExpanded"
                src="@/assets/htp/free-prizes-banner.png"
                class="col-12"
                alt=""
                @click="toggleFreePrizes"
                style="cursor: pointer;"
                key="collapsed"
            >
            <img
                v-else
                src="@/assets/htp/expanded-free-prizes-banner.png"
                class="col-12"
                alt=""
                @click="toggleFreePrizes"
                style="cursor: pointer;"
                key="expanded"
            >
          </transition>
        </div>
      </div>

    </div>
    <div v-if="openTab === 'vip'" class="d-flex flex-column justify-content-center align-items-center col-11 mt-4">
      <div class="d-flex flex-column justify-content-start align-items-center col-12 position-relative"
           style="
     height: 38vh;
      border-radius: 11px;
      background: rgba(255, 255, 255, 0.80);"
      >
        <div class="d-flex justify-content-center align-items-center col-12">
          <div class="col-5 mt-3">
            <div class="fw-bold col-12 heading mb-2">{{ currentVipHeading }}</div>
            <div class="col-12 text-start" style="white-space: pre-line;">{{ currentVipText }}</div>
          </div>
          <div class="col-5">
            <img :src="require(`@/assets/htp/${currentVipImage}.png`)" class="col-12" />
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center gap-2 mt-3 mb-3 col-5" style="position: absolute; bottom: 0; ">
          <img
              :src="currentVipSlide > 1 ? leftButtonActive : leftButtonInactive"
              class="col-3"
              @click="previousVipSlide"
              :style="currentVipSlide > 1 ? 'cursor: pointer' : ''"
          />
          <img
              :src="currentVipSlide < totalVipSlides ? rightButtonActive : rightButtonInactive"
              class="col-3"
              @click="nextVipSlide"
              :style="currentVipSlide < totalVipSlides ? 'cursor: pointer' : ''"
          />
        </div>
      </div>

      <div class="d-flex flex-column justify-content-center align-items-start mt-4 col-12">
        <div class="fw-bold text-start" style="font-size: 18px">Available Prizes</div>
        <div class="d-flex flex-column justify-content-center align-items-center col-12">
          <transition name="accordion" mode="out-in">
            <img
                v-if="!vipPrizesExpanded"
                src="@/assets/htp/vip-prizes-banner.png"
                class="col-12"
                alt=""
                @click="toggleVipPrizes"
                style="cursor: pointer;"
                key="collapsed"
            >
            <img
                v-else
                src="@/assets/htp/expanded-vip-prizes-banner.png"
                class="col-12"
                alt=""
                @click="toggleVipPrizes"
                style="cursor: pointer;"
                key="expanded"
            >
          </transition>
        </div>
      </div>

    </div>

  </div>
</template>

<style scoped>
/* Accordion animation */
.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.3s ease;
}

.accordion-enter-from {
  transform: scaleY(0);
  opacity: 0;
}

.accordion-leave-to {
  transform: scaleY(0);
  opacity: 0;
}

.accordion-enter-to,
.accordion-leave-from {
  transform: scaleY(1);
  opacity: 1;
}

.tutorial-btn {
  border-radius: 21px;
  background: #FFCB05;
  padding: 10px;
}

.tab-text-inactive {
  font-size: 16px;
  font-weight: bold;
  color: #7C0096;
}

.tab-text {
  font-size: 16px;
  font-weight: bold;
}

.tab-underline-inactive {
  border-bottom: 1px solid rgba(0, 15, 86, 0.20);
  height: 3px;
}

.tab-underline {
  border-radius: 5px;
  padding-bottom: 4px;
  background: #7C0096;
}

.heading {
  font-size: 18px;
}
</style>